import React from 'react';
import styled from 'styled-components';
import { ResponseContainer } from './DisplayContainer';
import { Box as MuiBox } from '@mui/material';
import { FileIcon, defaultStyles } from 'react-file-icon';

const FileDisplay = (props) => {
  const { value } = props;

  const fileExtension = value.split('.').slice(-1)[0];

  return (
    <ResponseContainer>
      <SMuiBox>
        <SDiv>
          <FileIcon
            extension={fileExtension}
            {...defaultStyles[fileExtension]}
          />
        </SDiv>
        {value}
      </SMuiBox>
    </ResponseContainer>
  );
};

export default FileDisplay;

const SMuiBox = styled(MuiBox)`
  && {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: left;
    margin: 0 5px;
  }
`;

const SDiv = styled.div`
  && {
    display: flex;
    align-items: center;
    width: 24px;
    margin: 5px 0;
    margin-right: 10px;
  }
`;
